/**
 * @file contains functions used to create urls to reroute via <Link /> or navigate
 * Can be same with the path routes, but we keep urls to be future-proof
 */

import { ROUTE__SMART_VIEWS } from '../../constants/routing/routes';
import { SEARCH_PARAM__SIDEBAR } from '../../constants/routing/searchParams';
import { SIDEBAR__PARAM_SMART_VIEWS } from '../../constants/sidebar';
import { Hotel } from '../../generated/graphql';
import { reportError } from '../../services/reporting';

/**
 * Get URL for /smart-views route
 *
 * @param hotelId  ID of the hotel
 * @param id       ID of the smart view we want to go to
 * @param isTablet Whether the device is a tablet
 * @returns        A string in a url format
 */
export const getSmartViewsSmartViewUrl = (
  hotelId: Hotel['id'] | null,
  id: string,
  isTablet: boolean,
): string => {
  if (hotelId === null) {
    reportError('HotelId in getSmartViewsSmartViewUrl was null');
  }

  const search = isTablet
    ? ''
    : `?${SEARCH_PARAM__SIDEBAR}=${SIDEBAR__PARAM_SMART_VIEWS}`;

  return `/${hotelId}/${ROUTE__SMART_VIEWS}/${id}${search}`;
};
